
import { useSelector } from 'react-redux'
import Nav from './NavBar'
import Sidebar from './Sidebar'


export default function Layout(props) {
  const { sidebarCollapsed } = useSelector(state => state.misc)

  return (
    <div className="h-screen overflow-x-hidden">
      <Nav />
      <Sidebar />

      <main className={`w-full mx-auto pt-20 pb-10 col-span-4 trans px-[30px] ${sidebarCollapsed ? '' : 'lg:pl-[296px]'}`}>
        {props.children}
      </main>
    </div>
  )
}
